import React, { Component, PropTypes } from "react"
import pgsIcon from "app/styles/images/sp/pgs.svg"
import pgdIcon from "app/styles/images/sp/pgd.svg"
import azfIcon from "app/styles/images/sp/azf.svg"
import ecsIcon from "app/styles/images/sp/ecs.svg"
import arrayPgtIcon from 'app/styles/images/sp/array-pgt.png'
import { setCurrentApp } from "app/api/localTools"

const APP_TYPE = {
  pgs: {
    style: "app-pgs",
    shadow: "pgs",
    name: "PGS/gDNA",
    icon: pgsIcon
  },
  pgd: {
    style: "app-pgd",
    shadow: "pgd",
    name: "PGD",
    icon: pgdIcon
  },
  azf: {
    style: "app-azf",
    shadow: "azf",
    name: "AZF",
    icon: azfIcon
  },
  ecs: {
    style: "app-ecs",
    shadow: "ecs",
    name: "ECS",
    icon: ecsIcon
  },
  'array-pgt': {
    style: "array-pgt",
    shadow: "array-pgt",
    name: "Array PGT",
    icon: arrayPgtIcon
  }
}

export default class AppCard extends Component {
  openApp = () => {
    const { app, history } = this.props
    setCurrentApp(app)
    history.push(`/jab/${app}/entrance`)
  }

  render() {
    const { app } = this.props

    return (
      <div className={"app-card " + APP_TYPE[app].style} onClick={this.openApp}>
        <img
          src={APP_TYPE[app].icon}
          className="app-icon"
          alt="app"
          style={app === 'array-pgt' ? { width: '75px', height: '55px' } : null}
        />
        <div className="app-name">{APP_TYPE[app].name}</div>
        <div className={"card-shadow " + APP_TYPE[app].shadow} />
      </div>
    )
  }
}

AppCard.propTypes = {
  app: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/app/pages/apps/containers/AppCard.js